import styled from '@emotion/styled';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';

import Container from '~/components/layout/Container';

import { SocialLinkList } from '~/components/Footer';
import { H2, SubTitle } from '~/components/Typography';
import GravityFormModal from '~/components/form/GravityFormModal';

const OuterWrapper = styled.div`
    background-color: ${({ theme }) => theme.palette.lemon};
    padding: 25px 0;
    bottom: 0;
    z-index: 11;

    @media (min-width: ${({ theme }) => theme.screenSizes.md}) {
        position: sticky;
    }
`;

const InnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media (min-width: ${({ theme }) => theme.screenSizes.md}) {
        flex-direction: row;
    }
`;

const BannerLeft = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    gap: 20px;

    @media (min-width: ${({ theme }) => theme.screenSizes.md}) {
        text-align: left;
    }
`;

const Title = styled(H2)`
    margin-bottom: 0;
`;

const SubscribeButton = styled.button`
    appearance: none;
    background: none;
    border: 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
`;

const StyledSubTitle = styled(SubTitle)`
    margin-bottom: 0;

    ${SubscribeButton}:hover &,
    ${SubscribeButton}:focus & {
        color: ${({ theme }) => theme.palette.white};
    }
`;

const NewsBannerRender = ({ title, subscribeButtonLabel, socialLinks }) => {
    const [open, setOpen] = useState(false);

    return (
        <OuterWrapper>
            <Container>
                <InnerWrapper>
                    <BannerLeft>
                        <Title>{title ?? 'Get more MCNC News'}</Title>
                        <>
                            <SubscribeButton
                                type="button"
                                onClick={() => setOpen(true)}
                            >
                                <StyledSubTitle>
                                    {subscribeButtonLabel ?? 'Subscribe >'}
                                </StyledSubTitle>
                            </SubscribeButton>
                            <GravityFormModal
                                {...{ open }}
                                title="Subscribe"
                                onClose={() => setOpen(false)}
                                onSuccess={() => setOpen(false)}
                            />
                        </>
                    </BannerLeft>

                    <SocialLinkList
                        links={socialLinks.links}
                        linkColor="white"
                        noMarginBottom
                        noPadding
                    />
                </InnerWrapper>
            </Container>
        </OuterWrapper>
    );
};

const NewsBanner = () => {
    const staticData = useStaticQuery(graphql`
        query {
            wp {
                mcncOptions {
                    footerOptions {
                        socialLinks {
                            links {
                                url
                                label
                            }
                        }
                    }
                    newsOptions {
                        title
                        subscribeButtonLabel
                    }
                }
            }
        }
    `);

    const {
        wp: {
            mcncOptions: {
                newsOptions: { title, subscribeButtonLabel },
                footerOptions: { socialLinks }
            }
        }
    } = staticData;

    return (
        <NewsBannerRender
            {...{
                title,
                subscribeButtonLabel,
                socialLinks
            }}
        />
    );
};

export default NewsBanner;
